import type { Theme } from '@mui/material/styles';

export const formattedValueHintStyles = {
	popper: (theme: Theme) => ({
		zIndex: theme.zIndex.tooltip
	}),

	wrapper: {
		position: 'relative',
		display: 'inline-block',
		filter:
			'drop-shadow(0 1px 2px rgba(0,0,0,0.06)) drop-shadow(0 4px 10px rgba(0,0,0,0.1))'
	},

	bubble: {
		position: 'relative',
		display: 'flex',
		alignItems: 'flex-start',
		gap: '6px',
		width: 'max-content',
		minWidth: '150px',
		boxSizing: 'border-box',
		fontSize: '12px',
		lineHeight: 1.4,
		whiteSpace: 'pre-line',
		wordBreak: 'break-word',
		color: 'text.secondary',
		padding: '6px 10px',
		borderRadius: '6px',
		backgroundColor: 'background.paper',
		border: '1px solid',
		borderColor: 'divider',
		'& svg': {
			fontSize: '15px',
			marginTop: '1px',
			flexShrink: 0,
			color: 'info.main'
		}
	},

	bubbleError: {
		color: 'error.main',
		'& svg': {
			color: 'error.main'
		}
	},

	bubbleDynamic: (maxWidthPx: number | undefined, shiftPx: number) => ({
		...(maxWidthPx ? { maxWidth: `${maxWidthPx}px` } : null),
		transform: shiftPx ? `translateX(-${shiftPx}px)` : undefined
	}),

	arrow: {
		position: 'absolute',
		top: '-7px',
		left: '14px',
		width: 0,
		height: 0,
		borderLeft: '7px solid transparent',
		borderRight: '7px solid transparent',
		borderBottomWidth: '7px',
		borderBottomStyle: 'solid',
		borderBottomColor: 'divider',
		'&::after': {
			content: '""',
			position: 'absolute',
			top: '1px',
			left: '-6px',
			width: 0,
			height: 0,
			borderLeft: '6px solid transparent',
			borderRight: '6px solid transparent',
			borderBottomWidth: '6px',
			borderBottomStyle: 'solid',
			borderBottomColor: 'background.paper'
		}
	}
};
